import React from "react";
import { checkForDecimalNumbers, getPrice } from "../helper";

export interface ISimpleTextInput {
  name: string;
  value?: string;
  onChange: (name: string, value: any) => void;
  placeholder?: string;
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  kind?: "number" | "priceWithDecimals";
  disabled?: boolean;
  onMouseDown?: (e: React.MouseEvent) => void;
  /** Muted reference value shown on the opposite side of the input (e.g. the currently-saved value). */
  extraText?: any;
}

const SimpleTextInput = ({
  name,
  onChange,
  value,
  className,
  placeholder,
  onKeyDown,
  kind,
  disabled,
  onMouseDown,
  extraText,
}: ISimpleTextInput) => {
  const changeHandler = (newValue: string) => {
    if (kind === "number") {
      const num = getPrice(newValue);
      onChange(name, num);
    } else if (kind === "priceWithDecimals")
      onChange(name, checkForDecimalNumbers(newValue));
    else onChange(name, newValue);
  };

  const hasExtraText = extraText || extraText === 0;

  return (
    <div className="relative w-full h-full">
      <input
        placeholder={placeholder}
        type="text"
        name={name}
        onChange={(e) => changeHandler(e.target.value)}
        value={value}
        onKeyDown={onKeyDown}
        className={`border-2 border-gray-200 w-full h-full focus:border-gray-400 focus:outline-none transition rounded pr-1 pt-0.5 ${
          hasExtraText ? "!pl-9" : ""
        } ${className}`}
        disabled={disabled}
        onMouseDown={onMouseDown}
      />
      {hasExtraText ? (
        <div className="absolute top-1/2 -translate-y-1/2 left-2 text-xs text-gray-400 pointer-events-none">
          {extraText}
        </div>
      ) : null}
    </div>
  );
};

export default SimpleTextInput;
